<template>
  <div class="system-message-page">
    <van-nav-bar title="系统消息" left-arrow fixed placeholder @click-left="$router.back()" />
    <main class="message-content">
      <div v-if="loading" class="state-box"><van-loading color="#8b72e8">加载中...</van-loading></div>
      <div v-else-if="!messages.length" class="state-box empty-state">
        <van-icon name="envelop-o" />
        <p>暂无系统消息</p>
      </div>
      <article v-for="item in messages" :key="item.id" class="message-card">
        <div class="card-head">
          <span class="message-icon"><van-icon name="volume-o" /></span>
          <h2>{{ item.title }}</h2>
        </div>
        <p class="message-text">{{ item.content }}</p>
        <van-image v-if="item.image" class="message-image" :src="item.image" fit="cover" @click="previewImage(item.image)" />
        <time>{{ formatTime(item.create_time) }}</time>
      </article>
    </main>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  data() {
    return { loading: true, messages: [] };
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace('/Login');
      return;
    }
    this.loadMessages();
  },
  methods: {
    previewImage(url) { if (url) ImagePreview([url]); },
    loadMessages() {
      this.$http({ method: 'get', url: 'user_system_messages' }).then(res => {
        this.loading = false;
        if (res && res.code === 200) this.messages = res.data.messages || [];
        else this.$toast.fail((res && res.msg) || '系统消息加载失败');
      }).catch(() => {
        this.loading = false;
        this.$toast.fail('系统消息加载失败');
      });
    },
    formatTime(value) {
      const time = Number(value) * 1000;
      if (!time) return '';
      const d = new Date(time);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
  }
};
</script>

<style scoped>
.system-message-page { min-height: 100vh; background: #f6f5f2; color: #36303e; }
.system-message-page /deep/ .van-nav-bar { background: linear-gradient(135deg,#7c6ff0,#db6ea9); border-bottom: 0; }
.system-message-page /deep/ .van-nav-bar__title { color: #fff; font-size: 32px; font-weight: 700; }
.system-message-page /deep/ .van-icon-arrow-left { color: #fff; font-size: 34px; }
.system-message-page /deep/ .van-hairline--bottom::after { border-bottom-width: 0; }
.message-content { box-sizing: border-box; padding: 26px 24px 60px; }
.message-card { margin-bottom: 22px; padding: 26px 26px 22px; border: 1px solid rgba(124,111,240,.1); border-radius: 22px; background: #fff; box-shadow: 0 10px 26px rgba(45,35,65,.08); }
.card-head { display: flex; align-items: center; gap: 14px; }
.message-icon { display: flex; align-items: center; justify-content: center; width: 48px; height: 48px; border-radius: 50%; color: #fff; background: linear-gradient(135deg,#7c6ff0,#db6ea9); box-shadow: 0 5px 14px rgba(124,111,240,.24); }
.message-icon .van-icon { font-size: 28px; }
.card-head h2 { margin: 0; color: #36303e; font-size: 29px; line-height: 1.35; }
.message-text { margin: 20px 0 18px; color: #625b69; font-size: 26px; line-height: 1.65; white-space: pre-wrap; word-break: break-word; }
.message-image { display: block; width: 100%; height: 320px; margin: 0 0 18px; overflow: hidden; border-radius: 16px; background: #f4f1f6; }
.message-card time { display: block; color: #aaa3b1; font-size: 21px; text-align: right; }
.state-box { display: flex; align-items: center; justify-content: center; min-height: 45vh; color: #aaa3b1; font-size: 25px; }
.empty-state { flex-direction: column; gap: 15px; }
.empty-state .van-icon { color: #9c72dd; font-size: 76px; }
.empty-state p { margin: 0; }
</style>
